import { render } from "./EnRestrictedAccess.vue?vue&type=template&id=36ce3597"
import script from "./EnRestrictedAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./EnRestrictedAccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/pages/EnRestrictedAccess/EnRestrictedAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36ce3597"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36ce3597', __exports__)) {
    api.reload('36ce3597', __exports__)
  }
  
  module.hot.accept("./EnRestrictedAccess.vue?vue&type=template&id=36ce3597", () => {
    api.rerender('36ce3597', render)
  })

}


export default __exports__